const colors = {
  violet: "#532c6e",
  orange: "#ffb72b",
  blue: "#58b4e5",
  green: "#c3d631",
  darkViolet: "#270041",
}

export default colors
